import React from 'react';
import PropTypes from 'prop-types';

import {
  AditionalsIcon,
  AditionalsServicesIcon,
  DiscountIcon,
  FixedChargeIcon,
} from '@womcorp/wom-miwom-ui-kit/dist/@theme/assets/svg/icons/invoices';
import { HeadingContainer } from './styles/ItemHeadingStyled';

const ItemHeading = ({ data }) => {
  const mapIcons = {
    'Cargo fijo': <FixedChargeIcon />,
    'Cargos adicionales': <AditionalsIcon />,
    'Servicios adicionales': <AditionalsServicesIcon />,
    Descuentos: <DiscountIcon />,
  };
  const { name } = data;
  const iconToShow = mapIcons[name] || <FixedChargeIcon />;
  return (
    <HeadingContainer>
      <div>{iconToShow}</div>
      <strong>{name}</strong>
    </HeadingContainer>
  );
};

ItemHeading.propTypes = {
  data: PropTypes.shape({
    name: PropTypes.string,
    amount: PropTypes.number,
  }).isRequired,
};

export default ItemHeading;
